module.exports = __webpack_public_path__ + "img/icon-reg-payout-setting.78fea42e.png";